export const renderAsString = (value: any): string => {
  if (value == null) {
    return '';
  }

  if (typeof value === 'string') {
    return value;
  }

  if (typeof value === 'object') {
    // TODO (Amy): pretty print json
    return JSON.stringify(value, null, 2);
  }

  return String(value);
};
